import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Modal,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Paper,
  Tooltip,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UpdateLession = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  let navigate = useNavigate();
  const [subjectName, setSubjectName] = useState([]);
  const [className, setClassName] = useState([]);
  const [topicName, setTopicName] = useState([]);
  const [formData, setFormData] = useState({
    class: '',
    subject: '',
    lession: '',
    Content: '',
    pdfFile: null,
  });

  const { LessionId } = useParams();

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    if (field === 'class') {
      fetchSubjectddl(value);
    } else if (field === 'subject') {
      fetchTopicddl(value, formData.subject);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFormData((prevData) => ({
      ...prevData,
      pdfFile: file,
    }));
  };

  const handleSave = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/OfflineLessoon/Id?Id=${LessionId}`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classId: formData.class,
          subId: formData.subject || 2,
          lessonName: formData.lession,
          lessonContent: formData.Content,
          lessionPdfUrl: 'string',
        }),
      });
      if (response.ok) {
        setShowSuccessModal(true);
      } else {
        console.error('Failed to save form data');
      }
    } catch (error) {
      console.error('Save operation error:', error);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const fetchClassddl = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data !== null) {
          setClassName(responseData);
        } else {
          console.error('No data found for classes');
        }
        if (responseData.msg && responseData.msg !== 'Record Not Found') {
          console.error('API error:', responseData.msg);
        }
      } else {
        console.error('Failed to fetch class data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const fetchSubjectddl = async (classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Question/ddlSubject`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classId,
          subjectId: 0,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data !== null) {
          setSubjectName(responseData);
        } else {
          console.error('No data found for subjects');
        }
        if (responseData.msg && responseData.msg !== 'Record Not Found') {
          console.error('API error:', responseData.msg);
        }
      } else {
        console.error('Failed to fetch subject data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const fetchTopicddl = async (classId, subjectId) => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Question/ddlLession`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classId,
          subjectId,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data !== null) {
          setTopicName(responseData);
        } else {
          console.error('No data found for topics');
        }
        if (responseData.msg && responseData.msg !== 'Record Not Found') {
          console.error('API error:', responseData.msg);
        }
      } else {
        console.error('Failed to fetch topic data');
        // alert('Failed to fetch topic data');
        setSnackbarMessage('Failed to fetch topic data');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")

      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const fetchLessionDetails = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/OfflineLessoon/GetLesson`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const responseData = await response.json();
        console.log('Fetched Lesson Details:', responseData);
        const lessionDetails = responseData.find((item) => item.lessonId == LessionId);
        if (lessionDetails) {
          console.log('Found Lesson Details:', lessionDetails);
          setFormData({
            class: lessionDetails.classId,
            subject: lessionDetails.subjectName || '',
            lession: lessionDetails.lessonName,
            Content: lessionDetails.lessonContent,
          });
        } else {
          console.error('No data found for this lesson');
        }
      } else {
        console.error('Failed to fetch lesson details');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  useEffect(() => {
    fetchClassddl();
    if (LessionId) {
      fetchLessionDetails();
    }
  }, [LessionId]);

  return (
    <Box p={3}>
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          maxWidth: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Update Lesson
        </Typography> </Box>
      <Paper elevation={3} sx={{ padding: 2, marginBottom: 2, marginTop: 1 }}>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel>Class *</InputLabel>
          <Select
            value={formData.class}
            label="Class *"
            onChange={(e) => handleChange('class', e.target.value)}
          >
            {className.map((item) => (
              <MenuItem key={item.classId} value={item.classId}>
                {item.className}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel>Subject *</InputLabel>
          <Select
            value={formData.subject}
            label="Subject *"
            onChange={(e) => handleChange('subject', e.target.value)}
          >
            {subjectName.map((item) => (
              <MenuItem key={item.subjectId} value={item.subjectId}>
                {item.subjectName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Lesson"
          value={formData.lession}
          onChange={(e) => handleChange('lession', e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          fullWidth
          label="Lesson Content"
          multiline
          rows={4}
          value={formData.Content}
          onChange={(e) => handleChange('Content', e.target.value)}
          sx={{ marginBottom: 2 }}
        />
      </Paper>
      <Box>
        <Tooltip title={(!formData.class || !formData.subject) && "Please fill required fields"} arrow><span>
          <Button variant="contained" color="primary" onClick={handleSave} sx={{
            marginRight: 1, width: "90px",
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold'
          }}
            disabled={!formData.class || !formData.subject}>
            SAVE
          </Button></span></Tooltip>
        <Button variant="contained" color="error" onClick={handleCancel} sx={{
          width: "90px",
          height: "50px",
          padding: "10px 0",
          fontWeight: 'bold'
        }}>
          CANCEL
        </Button>
      </Box>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Lesson Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Lesson has been Updated successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </Box>
  );
};

export default UpdateLession;
